import Vue from "vue";

export const ACCESS_SUSPENSION_TYPE = {
  TRIAL: "TRIAL",
  OVERDUE: "OVERDUE",
};

export const accessSuspension = Vue.observable({
  active: false,
  type: null, // one of ACCESS_SUSPENSION_TYPE
  blockedDb: null,
  details: null, // manager-only `suspension` object of the 403 body, if any
});

export function setAccessSuspension(active, { type = null, blockedDb = null, details = null } = {}) {
  accessSuspension.active = !!active;
  accessSuspension.type = active ? type || accessSuspension.type || null : null;
  accessSuspension.blockedDb = active
    ? blockedDb || accessSuspension.blockedDb || null
    : null;
  accessSuspension.details =
    active && details && typeof details === "object" ? details : null;
}

export function setAccessSuspensionForDb(type, dbName, details = null) {
  setAccessSuspension(true, { type, blockedDb: dbName || null, details });
}

export function clearAccessSuspension() {
  setAccessSuspension(false);
}

